export class CashRegisterXReportVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  